"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var renderSizeInfo_1 = __importDefault(require("../customSection/renderSizeInfo"));
var sumCalorie_1 = __importDefault(require("../titleSection/sumCalorie"));
var selectModalTitle_1 = __importDefault(require("./selectModalTitle"));
var updateSizeState_1 = __importDefault(require("../updateState/updateSizeState"));
var checkQuantity_1 = __importDefault(require("../customSection/checkQuantity"));
var updateQuantityState_1 = __importDefault(require("../updateState/updateQuantityState"));
var renderSelectedItem_1 = require("../customSection/renderSelectedItem");
var updateSelectedState_1 = require("../updateState/updateSelectedState");
var uncheckItem_1 = __importDefault(require("../chooseSection/uncheckItem"));
var $mainChoose = document.querySelector('.main__choose');
var $checkedItemList = document.querySelector('.custom__list-dynamic');
var $sizeList = document.querySelector('.size__item');
exports.default = (function () {
    $mainChoose.addEventListener('change', function (e) {
        var target = e.target;
        if (target.matches('#size1') || target.matches('#size2'))
            return;
        if (target.type === 'checkbox') {
            (0, updateSelectedState_1.updateDynamicList)(target);
            (0, renderSelectedItem_1.renderDynamicList)();
        }
        else if (target.type === 'radio') {
            (0, updateSelectedState_1.updateStaticList)(target);
            // renderStaticList();
            if (target.name === 'bread')
                (0, renderSelectedItem_1.renderBreadName)();
            else if (target.name === 'meats')
                (0, renderSelectedItem_1.renderMeatsName)();
        }
        (0, sumCalorie_1.default)();
        (0, selectModalTitle_1.default)(target);
    });
    $sizeList.addEventListener('click', function (e) {
        (0, updateSizeState_1.default)(e);
        (0, renderSizeInfo_1.default)();
        (0, sumCalorie_1.default)();
        (0, selectModalTitle_1.default)(e.target);
    });
    $checkedItemList.addEventListener('change', function (e) {
        var target = e.target;
        if (+target.value === 1 || +target.value === 10) {
            target.addEventListener('click', function addActiveClass() {
                var $popUp = document.querySelector('.custom__alertPopup');
                $popUp.classList.add('active');
                $popUp.addEventListener('animationend', function () {
                    $popUp.classList.remove('active');
                    target.removeEventListener('click', addActiveClass);
                });
            });
        }
        (0, checkQuantity_1.default)(target);
        (0, updateQuantityState_1.default)(target);
        (0, sumCalorie_1.default)();
    });
    $checkedItemList.addEventListener('click', function (e) {
        var _a, _b;
        var target = e.target;
        if (target.matches('i.fa-times-circle')) {
            var $upperInput = (_b = (_a = target.parentNode) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.firstElementChild;
            (0, updateSelectedState_1.deleteCheckedItem)($upperInput);
            (0, renderSelectedItem_1.renderDynamicList)();
            (0, selectModalTitle_1.default)($upperInput);
            (0, uncheckItem_1.default)($upperInput);
        }
    });
});
